const $ = jQuery.noConflict();

const anchorScroll = () => {
	// Cache DOM
	const $window = $(window);
	const $document = $(document);
	const body = $('html, body');
	const header = body.find('header.header');
	const nav = header.find('.header__nav');
	const menuItems = nav.find('> ul > li > a[href^="#"]');
	const menuTrigger = header.find('.header__mobile-btn');
	const sections = body.find('section.section').filter((i, elem) => $(elem).attr('id') !== undefined);

	// Functions
	const markCurrentSection = () => {
		const scrollTop = $window.scrollTop() + header.outerHeight();

		sections.each((i, element) => {
			const elemOffTop = $(element).offset().top;
			const elemOffBottom = elemOffTop + $(element).outerHeight();
			const nextElem = sections.eq(i + 1);
			const nextElemOffTop = nextElem.length ? nextElem.offset().top : elemOffBottom;

			if (scrollTop >= elemOffTop && scrollTop < nextElemOffTop) {
				const link = $(element).attr('id');
				if (link !== undefined) {
					menuItems.each((index, item) => {
						if ($(item).attr('href') === `#${link}`) {
							$(item).addClass('active');
							if ($window.width() < 768 && (menuTrigger.text() !== $(item).text())) menuTrigger.text($(item).text());
						} else {
							$(item).removeClass('active');
						}
					});
				}
			}

			// if (scrollTop >= elemOffTop) {
			// 	const link = $(element).attr('id');

			// 	if (link !== undefined) {
			// 		menuItems.each((index, item) => {
			// 			if ($(item).attr('href') === `#${link}`) {
			// 				if (!$(item).hasClass('active')) $(item).addClass('active');
			// 				if ($window.width() < 768) menuTrigger.text($(item).text());
			// 			} else {
			// 				if ($(item).hasClass('active')) $(item).removeClass('active');
			// 			}
			// 		});
			// 	}
			// }
		});
	};

	const scrollToSection = (e) => {
		e.preventDefault();
		$document.off('scroll resize');

		const link = $(e.target).attr('href');
		const section = sections.filter((i, elem) => $(elem).attr('id') === `${link.substring(1)}`);

		if (section.length === 1) {
			menuItems.removeClass('active');
			$(e.target).addClass('active');
			if ($window.width() < 768) menuTrigger.text($(e.target).text());

			body.animate({
				scrollTop: section.offset().top - (header.height() - 1),
			}, 600, 'swing', () => {
				$document.on('scroll resize', markCurrentSection);
			});
		}
	};

	// Bind Events
	menuItems.on('click', scrollToSection);
	$document.on('scroll resize', markCurrentSection);
	// markCurrentSection();
	setTimeout(() => {
		markCurrentSection();
	}, 50);
};

export default anchorScroll;
